import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import LandingPage from "../pages/landing/page";

function HomeRedirect() {
  const host = window.location.hostname;
  if (host === "app.floraiq.com.br" || host === "localhost") {
    return <Dashboard />;
  }
  return <Navigate to="/landing" replace />;
}
import PublicPortalPage from "../pages/publico/page";
import ColetorPage from "../pages/coletor/page";
import Dashboard from "../pages/dashboard/page";
import Projetos from "../pages/projetos/page";
import ProjectDetail from "../pages/projetos/detail/page";
import CTA from "../pages/cta/page";
import FCAPage from "../pages/cta/fca/page";
import Mapa from "../pages/mapa/page";
import Vistorias from "../pages/vistorias/page";
import TerritorioInspecoesPage from "../pages/territorio/inspecoes/page";
import TerritorioQuadrasPage from "../pages/territorio/quadras/page";
import TerritorioArvoresPage from "../pages/territorio/arvores/page";
import TerritorioIndicadoresPage from "../pages/territorio/indicadores/page";
import TerritorioConsoleWebgisPage from "../pages/territorio/console-webgis/page";
import AreasVerdes from "../pages/ambiental/areas-verdes/page";
import UCs from "../pages/ambiental/ucs/page";
import Carbono from "../pages/carbono/page";
import Documentos from "../pages/documentos/page";
import Partes from "../pages/partes/page";
import Responsabilidades from "../pages/responsabilidades/page";
import Relatorios from "../pages/relatorios/page";
import Configuracoes from "../pages/configuracoes/page";
import Ambiental from "../pages/ambiental/page";
import LadmMethodology from "../pages/ladm/page";
import PointCloudPage from "../pages/nuvem3d/page";
import DataQualityPage from "../pages/qualidade/page";
import OperationalFlowPage from "../pages/operacional/page";
import MemorialDescritivoPage from "../pages/memorial/page";
import PilotoSBVPage from "../pages/piloto-sbv/page";

const routes: RouteObject[] = [
  {
    path: "/landing",
    element: <LandingPage />,
  },
  {
    path: "/publico",
    element: <PublicPortalPage />,
  },
  {
    path: "/coletor",
    element: <ColetorPage />,
  },
  {
    path: "/coletor/nova-arvore",
    element: <ColetorPage />,
  },
  {
    path: "/coletor/vistoria",
    element: <ColetorPage />,
  },
  {
    path: "/coletor/fotos",
    element: <ColetorPage />,
  },
  {
    path: "/coletor/mapa",
    element: <ColetorPage />,
  },
  {
    path: "/coletor/rascunhos",
    element: <ColetorPage />,
  },
  {
    path: "/coletor/sincronizacao",
    element: <ColetorPage />,
  },
  {
    path: "/coletor/qrcode",
    element: <ColetorPage />,
  },
  {
    path: "/coletor/fca",
    element: <ColetorPage />,
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomeRedirect />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "projetos",
        element: <Projetos />,
      },
      {
        path: "projetos/:id",
        element: <ProjectDetail />,
      },
      {
        path: "cta",
        element: <CTA />,
      },
      {
        path: "cta/:id",
        element: <FCAPage />,
      },
      {
        path: "mapa",
        element: <Mapa />,
      },
      {
        path: "vistorias",
        element: <Vistorias />,
      },
      {
        path: "territorio/inspecoes",
        element: <TerritorioInspecoesPage />,
      },
      {
        path: "territorio/quadras",
        element: <TerritorioQuadrasPage />,
      },
      {
        path: "territorio/arvores",
        element: <TerritorioArvoresPage />,
      },
      {
        path: "territorio/indicadores",
        element: <TerritorioIndicadoresPage />,
      },
      {
        path: "territorio/console-webgis",
        element: <TerritorioConsoleWebgisPage />,
      },
      {
        path: "ambiental",
        element: <Ambiental />,
      },
      {
        path: "ambiental/areas-verdes",
        element: <AreasVerdes />,
      },
      {
        path: "ambiental/ucs",
        element: <UCs />,
      },
      {
        path: "carbono",
        element: <Carbono />,
      },
      {
        path: "documentos",
        element: <Documentos />,
      },
      {
        path: "partes",
        element: <Partes />,
      },
      {
        path: "responsabilidades",
        element: <Responsabilidades />,
      },
      {
        path: "relatorios",
        element: <Relatorios />,
      },
      {
        path: "configuracoes",
        element: <Configuracoes />,
      },
      {
        path: "metodologia",
        element: <LadmMethodology />,
      },
      {
        path: "nuvem3d",
        element: <PointCloudPage />,
      },
      {
        path: "qualidade",
        element: <DataQualityPage />,
      },
      {
        path: "operacional",
        element: <OperationalFlowPage />,
      },
      {
        path: "memorial",
        element: <MemorialDescritivoPage />,
      },
      {
        path: "piloto/sbv",
        element: <PilotoSBVPage />,
      },
    ],
  },
  {
    path: "/app",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "cta",
        element: <CTA />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
